import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import {
	formatPactoRebatesParamsPayload,
	formatPactoRebatesParamsResponse,
	validatePactoRebatesParamsPayload
} from "../../utils/pacto-rebates-params-utils";
import { hasValidationErrors } from "../../../utils/validation-utils";

export function usePactoRebatesParamsUpdate() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [validationErrors, setValidationErrors] = useState({});

	const validatePactoRebatesParams = values => {
		const errors = validatePactoRebatesParamsPayload(values);

		setValidationErrors(errors);

		return errors;
	};

	async function updatePactoRebatesParams(payloadData) {
		const errors = validatePactoRebatesParamsPayload(payloadData);

		if (hasValidationErrors(errors)) {
			setValidationErrors(errors);
			setError(null);

			return {
				ok: false,
				reason: "validation",
				validationErrors: errors
			};
		}

		try {
			setLoading(true);
			setError(null);
			setValidationErrors({});

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const body = formatPactoRebatesParamsPayload(payloadData);

			const requestOptions = {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				},
				body: JSON.stringify(body)
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					"pacto-rebates-admin/v1/configuracoes",
				requestOptions
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível editar os parâmetros do Pacto Rebates."
				);
			}

			const data = await response.json();

			const pactoRebatesParamsData = Array.isArray(data.resultado)
				? data.resultado[0]
				: data.resultado || data;

			const formattedPactoRebatesParams = formatPactoRebatesParamsResponse(pactoRebatesParamsData);

			return {
				ok: true,
				pactoRebatesParams: formattedPactoRebatesParams
			};
		} catch (requestError) {
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		loading,
		error,
		validationErrors,
		validatePactoRebatesParams,
		updatePactoRebatesParams
	};
}